module.exports = __webpack_public_path__ + "static/media/band_dj.a17895bd.svg";